// Styles here will override Bulma styles
import { css } from '@emotion/core';

export const lazyLinkStyles = css`
  &.button-link {
    align-items: center;
    background-color: transparent;
    border: 1px solid #001430;
    border-radius: 100px;
    color: #001430;
    cursor: pointer;
    display: flex;
    font-family: 'WorkSans-Bold', 'Helvetica', 'san-serif';
    font-size: 1em;
    justify-content: center;
    padding: 16px 32px;
    transition: all 0.3s ease;

    :hover {
      background-color: rgba(0, 105, 255, 0.15) !important;
      color: #001430 !important;
      transition: all 0.3s ease;
    }

    :focus {
      background-color: rgba(0, 105, 255, 0.15);
      border: 1px solid transparent;
      color: #0069ff;
    }

    /* Blue button - primary blue is set in _variables stylesheet */
    &.is-primary {
      background-color: #1633ff;
      border: 1px solid #1633ff;
      color: #fff;
      transition: all 0.3s ease;

      :hover {
        background-color: #0069ff !important;
        border: 1px solid #0069ff;
        color: #fff !important;
        transition: all 0.3s ease;
      }

      :disabled {
        background-color: #c4c9d6 !important;
        border: 1px solid #c4c9d6 !important;
        color: #fff;
      }

      &.is-outlined {
        border: 1px solid #0069ff;
        color: #0069ff;

        :hover {
          color: #0069ff !important;
          border: 1px solid #0069ff !important;
          background-color: #f2f8ff !important;
        }

        :disabled {
          background-color: #fff !important;
          border: 1px solid #8690a9 !important;
          color: #8690a9 !important;
        }
      }
    }

    /* White button */
    &.is-white {
      background-color: #fff;
      border: 1px solid #fff;
      color: #0069ff;
      transition: all 0.3s ease;

      :hover {
        border: 1px solid rgba(225, 225, 225, 0.9);
        color: #0069ff !important;
        background-color: rgba(225, 225, 225, 0.9) !important;
        transition: all 0.3s ease;
      }

      :disabled {
        border: 1px solid #8690a9 !important;
        color: #8690a9 !important;
      }

      /* White outlined button */
      &.is-outlined {
        background-color: transparent;
        border: 1px solid rgba(255, 255, 255, 0.8);
        color: rgba(255, 255, 255, 0.8);

        :hover {
          background-color: transparent !important;
          border: 1px solid rgba(255, 255, 255, 1);
          color: rgba(255, 255, 255, 1) !important;
        }
      }
    }

    /* default outlined button styles */
    &.is-outlined {
      background-color: transparent;
      border: 1px solid #001430;
      color: #001430;
      transition: all 0.3s ease;

      :hover {
        border: 1px solid #0069ff;
        color: #0069ff;
        transition: all 0.3s ease;
      }
    }

    /* small button styles */
    &.is-small {
      padding: 12px 24px;
    }

    /* circle button styles */
    &.has-center-img {
      padding: 15px 16px;
    }

    /* left image styles */
    &.has-left-img {
      > img {
        margin-right: 8px;
      }
    }

    /* margin top helper */
    &.mx-16 {
      margin-right: 16px;
    }
  }
`;
